import React from "react";
import { Menu, MenuItem, SxProps } from "@mui/material";
import { InheritLabel } from "./InlineTextEdit";

export interface InlineOptionsProps {
    text: string;
    options: string[];
    readOnly?: boolean;
    onEdit: (newValue: string) => void;
    sx?: SxProps;
}

export function InlineOptionSelect(props: InlineOptionsProps) {
    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLParagraphElement>) => {
        event.stopPropagation();
        if (!props.readOnly) {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function renderMenuItem(option: string) {
        return (
            <MenuItem
                key={option}
                onClick={(event: React.MouseEvent<HTMLLIElement>) => {
                    event.stopPropagation();
                    setAnchorEl(null);
                    if (props.onEdit) props.onEdit(option);
                }}
            >
                {option}
            </MenuItem>
        );
    }

    return (
        <>
            <InheritLabel
                sx={props.sx}
                onClick={handleClick}
                data-testid="InlineOptionSelect"
            >
                {props.text}
            </InheritLabel>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                keepMounted
                onClose={handleClose}
            >
                {props.options.map((option: string) => {
                    return renderMenuItem(option);
                })}
            </Menu>
        </>
    );
}
